import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { TextInput, Services, Modal, Text, Checkbox, i18n, tokens } from '@simplybenefits/sb-ui-library';
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

import { supportEmail, setCurrentSidebarItem } from '../../actions/user.js';

class Support extends Component {
    state = {
        subject: '',
        description: '',
        type: ''
    };

    componentDidMount() {
        this.props.dispatch(setCurrentSidebarItem('support'));
    }

    _onBlur = async (type) => {
        this.setState({
            [`${ type }Error`]: await Services.validateInput(type, this.state[type])
        });
    };

    _handleInputChange = (type, event) => {
        this.setState({
            [type]: event.target.value.toString()
        });
    };

    _validateForm = async () => {
        const subjectError = await Services.validateInput('subject', this.state.subject);
        const descriptionError = await Services.validateInput('description', this.state.description);

        this.setState({
            subjectError,
            descriptionError
        });

        if (
            subjectError ||
            descriptionError
        ) {
            return false;
        }

        return true;
    };

    _send = async () => {
        const {
            subject,
            description,
            type
        } = this.state;

        const { meta } = this.props;

        const isFormValid = await this._validateForm();

        if (!isFormValid) {
            return false;
        }

        const typeCapitalized = type.charAt(0).toUpperCase() + type.slice(1);

        const body = {
            firstname: meta.firstname,
            lastname: meta.lastname,
            email: meta.email,
            phone: meta.phone,
            subject: `(${ typeCapitalized.trim() }), ${ subject.trim() }`,
            description: description.trim()
        };

        const success = await this.props.dispatch(supportEmail(body));

        if (success) {
            this.props.close();
        }

        return null;
    };

    _setSupportType = (type) => {
        this.setState({ 
            type: type
        });
    };

    _callUs = () => {
        window.open(`tel:${ Services.constants.phoneNumberSupport }`, "_blank");
    };

    _navigateTo = () => {
        window.open("https://help.simplybenefits.ca/", "_blank");
    };

    render() {
        const {
            subject,
            description,
            type
        } = this.state;

        // if the group is private label then just display the whitelabelled support details
        if (this.props.meta.isPrivateLabel) {
            return (
                <FormModal
                    testid="support"
                    open={this.props.open}
                    close={this.props.close}
                    title={ i18n.t(tokens.labels.support.getInTouchWithSupport) }
                    customContainerStyle={{ width: 500 }}
                >
                    <Text
                        medium
                        light
                    >
                        { i18n.t(tokens.labels.support.contactSupportMessagePrivateLabel) }
                    </Text>

                    <Text
                        onClick={this._navigateTo}
                        customStyle={{ cursor: 'pointer' }}
                        margin="10px 0 10px"
                        align="center"
                        medium
                    >
                        { this.props.whitelabel.supportEmail }
                    </Text>

                    <Text
                        onClick={this._callUs}
                        customStyle={{ cursor: 'pointer' }}
                        align="center"
                        medium
                    >
                        { this.props.whitelabel.supportPhone }
                    </Text>
                </FormModal>
            );
        }

        return (
            <Modal
                testid="support"
                open={this.props.open}
                onClose={this.props.close}
                title={ i18n.t(tokens.labels.support.getInTouchWithSupport) }
                primaryButton={{
                    label: i18n.t(tokens.buttons.send),
                    onClick: this._send
                }}
            >
                <Text
                    medium
                    light
                >
                    { i18n.t(tokens.labels.support.chooseRelevantOrReachGeneralSupport) }
                </Text>

                <FormGroup row style={{ marginTop: 20, marginBottom: 40 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={type === 'contact'}
                                onChange={() => this._setSupportType('contact')}
                                value="contact"
                                color="secondary"
                            />
                        }
                        label={<Text avMedium>{ i18n.t(tokens.labels.support.generalRequest) }</Text>}
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={type === 'support'}
                                onChange={() => this._setSupportType('support')}
                                value="support"
                                color="secondary"
                            />
                        }
                        label={<Text avMedium>{ i18n.t(tokens.labels.support.technicalSupport) }</Text>}
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={type === 'adjudication'}
                                onChange={() => this._setSupportType('adjudication')}
                                value="adjudication"
                                color="secondary"
                            />
                        }
                        label={<Text avMedium>{ i18n.t(tokens.labels.support.pendingDeniedOrCancelledClaims) }</Text>}
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={type === 'administration'}
                                onChange={() => this._setSupportType('administration')}
                                value="administration"
                                color="secondary"
                            />
                        }
                        label={<Text avMedium>{ i18n.t(tokens.labels.support.changesToCoverage) }</Text>}
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={type === 'complaints'}
                                onChange={() => this._setSupportType('complaints')}
                                value="complaints"
                                color="secondary"
                            />
                        }
                        label={<Text avMedium>{ i18n.t(tokens.labels.support.complaints) }</Text>}
                    />
                </FormGroup>


                <Text
                    medium
                    light
                >
                    { i18n.t(tokens.labels.support.contactSupportMessage) }
                </Text>

                <TextInput
                    label={ i18n.t(tokens.labels.support.subject) }
                    value={subject}
                    onBlur={() => this._onBlur('subject')}
                    onChange={(value) => this._handleInputChange('subject', value)}
                    error={Boolean(this.state.subjectError)}
                    helperText={this.state.subjectError}
                    variant="outlined"
                    fullWidth
                />

                <TextInput
                    label={ i18n.t(tokens.labels.support.describeHowWeCanHelpYou) }
                    value={description}
                    onBlur={() => this._onBlur('description')}
                    onChange={(value) => this._handleInputChange('description', value)}
                    error={Boolean(this.state.descriptionError)}
                    helperText={this.state.descriptionError}
                    variant="outlined"
                    multiline
                    rows={6.5}
                    fullWidth
                />

                <Text
                    medium
                    light
                    margin="20px 0 10px"
                    align="center"
                >
                    { i18n.t(tokens.labels.support.visitHelpCenterOrPlaceCall) }
                </Text>

                <Text
                    onClick={this._navigateTo}
                    customStyle={{ cursor: 'pointer' }}
                    margin="10px 0 10px"
                    align="center"
                    small
                    light
                >
                    help.simplybenefits.ca
                </Text>

                <Text
                    onClick={this._callUs}
                    customStyle={{ cursor: 'pointer', marginBottom: -10 }}
                    align="center"
                    small
                    light
                >
                    { Services.constants.phoneNumberCanadaUSA }
                </Text>
            </Modal>
        );
    }
}

Support.propTypes = {
    loading: PropTypes.bool,
    meta: PropTypes.object
};

/**
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loading: state.user.loading,
    meta: state.user.meta,
    whitelabel: state.whitelabel
});

export default connect(mapStateToProps)(Support);